export default __webpack_public_path__ + "static/media/no-projects.85efb4bd.svg";